import { Timezone } from 'shared/types';

export const TIMEZONES: Timezone[] = [
  {
    value: '-5',
    title: 'Eastern Standard Time (GMT-5)',
    abbreviation: 'EST'
  },
  {
    value: '-6',
    title: 'Central Standard Time (GMT-6)',
    abbreviation: 'CST'
  },
  {
    value: '-7',
    title: 'Mountain Standard Time (GMT-7)',
    abbreviation: 'MST'
  },
  {
    value: '-8',
    title: 'Pacific Standard Time (GMT-8)',
    abbreviation: 'PST'
  }
];
